common:
  save: 保存
animations:
  stage-transitions:
    title: ステージ遷移を無効にする
  use-page-specific-transitions:
    description: >-
      一部のページには独自の遷移アニメーションがあり、ステージ遷移アニメーションを上書きします
    title: ページ固有の遷移を使用する
dialogs:
  onboarding:
    official:
      title: AIRI 公式プロバイダー
    title: AIRI へようこそ！
    description: まず最初のAIプロバイダーを設定しましょう。
    selectProvider: AIプロバイダーを選択
    configureProvider: 設定 {provider}
    apiKey: APIキー
    apiKeyHelp: '{provider}からAPIキーを取得し、ここに貼り付けてください'
    baseUrl: ベースURL
    baseUrlHelp: APIエンドポイントURL（不明な場合はデフォルトを使用）
    accountId: アカウントID
    validationRunning: テストを実行中
    validationSuccess: 設定検証に成功
    validationPartial: 設定の一部が検証されました
    validationFailed: 設定検証に失敗
    validationError: '検証エラー: {error}'
    testGeneration: Ping API
    testGenerationRunning: Ping中...
    testGenerationFailed: Pingテストに失敗
    retryPingCheck: 再試行
    skipForNow: 今はスキップ
    saveAndContinue: 保存して続行
    next: 次へ
    retry: 再試行
    credentialsSafeLabel: APIキーと認証情報は安全に管理してください！
    credentialsSafeLocal: >-
      AIRIはあなたのPC上で完全にローカル環境で動作しており、AI/LLMプロバイダー向けの認証情報を無断で取得することはありません。ただし、APIキーは機密情報であることを十分に認識してください。これらのキーは厳重に管理し、決して第三者と共有しないようご注意ください。
    credentialsSafeOpenSource: >-
      AIRIのソースコードは{github}で公開されています。認証情報の取り扱い方法を確認したい場合は、お気軽にコードをご確認ください。
    enableChatCheck: >-
      Airiが最初に利用できるチャットモデルに「ping」メッセージを送信して利用可能状況を確認することを許可する
    start: 始めましょう！
    loginPrompt: 最適な体験を提供するAIRI公式プロバイダーを利用するには、ログインしてください。
    loginAction: サインイン
    setupWithoutSigningIn: プロバイダーでセットアップ
    flux: Flux
    buyFlux: Fluxをチャージ
    select-model: モデルを選択
    no-models: 利用可能なモデルがありません
    no-models-help: >-
      前のステップに戻ってAPIキーを確認するか、ネットワーク接続を確認してください。
    permissions:
      title: 権限管理
      description: 今すぐ必要な権限を許可するか、続行して後で設定できます。
      notificationsTitle: 通知
      notificationsDescription: リマインダーと重要なステータス更新を許可する。
      microphoneTitle: マイク
      microphoneDescription: AIRI が音声入力と文字起こしにマイクを使用することを許可します。
      requestAction: アクセスをリクエスト
      optionalHint: これらの権限を許可しない場合でも続行できます。
      stateGranted: 許可済み
      stateNotGranted: 許可されていません
  bug-report:
    title: バク報告(´;ω;`)ヾ(･∀･`)
    subtitle: "予期せぬエラーが発生しました\n何が起こったか報告してくれませんか？"
    trigger-label: バグを報告
    submit-label: バグ報告を送信
    triage-description: この問題の解決のためにページ内容とスクリーンショットを含める。
    description-placeholder: Steps to reproduce, expected behavior, and actual behavior
    include-current-page-screenshot: Include current page screenshot
    manual-media:
      label: Manually choose screenshots / recordings
      optional: Optional.
    media-files:
      label: Media files
      description: 'Optional: manually select.'
      placeholder: Choose screenshot or video file
      selected-count: '{count} file(s) selected'
    last-submitted-preview: Last Submitted Payload Preview
language:
  title: 言語
  description: |
    UI の言語。キャラクターの言語は後で設定できます。
controls-island:
  icon-size:
    title: アイランドアイコンのサイズを制御
    description: アイランドアイコンのサイズを調整します
    auto: 自動 (レスポンシブ)
    large: 大 (デフォルト)
    small: 小
analytics:
  notice:
    title: 使用状況の分析
    description: >-
      AIRIは匿名の利用分析データを収集し、アプリの使用方法の把握と安定性の向上に役立てています。個人を特定できる情報は一切収集されません。
    privacyPrefix: 読む
    privacyLink: プライバシーポリシー
    onboardingHint: 分析機能は「設定」>「システム」>「一般」で後からオフにすることができます。
    settingsHint: 分析はいつでもオフにできます。
  toggle:
    title: 使用状況の分析を有効にする
    description: この機能を無効にすると、分析データの収集をオプトアウトできます。
  disabled:
    title: この開発ビルドでは分析が無効になっています
model-select:
  panel-callout:
    support-status-header: 私たちは2Dと3Dのモデル両方をサポートしています
    support-status: >
      Click {select-button} to select or import models. Currently, {zip} (for Live2D and Spine models), {vrm} (for VRM models), and {mmd} (for MMD models, zipped with their textures) are supported.
    model-type-example: >
      Neuro-sama uses 2D model driven by framework developed by Live2D Inc, while Grok Ani (in Grok Companion) uses 3D model driven by VRM / MMD open formats.
  select-model:
    title: Model Selector
    button: モデルを選択
    select: Pick
    import: インポート
    remove: Remove
    confirm: Confirm
live2d:
  change-model:
    from-file: ファイルから読み込む
    from-file-select: 選択
    from-url: URL から読み込む
    from-url-confirm: 読み込み
    from-url-placeholder: Live2DモデルのURLを入力
    title: モデルを変更
  edit-motion-map:
    title: モーションマップを編集
  map-motions:
    play: モーションを再生
    title: モーションをマップ
  title: Live2D設定
  scale-and-position:
    title: スケールと位置
    scale: スケール
    x: X
    'y': 'Y'
  switch-to-vrm:
    title: 3Dアバターに切り替えますか？
    change-to-vrm: 3Dアバター設定 (VRM) に切り替えるにはここをクリック
  theme-color-from-model:
    title: モデルから色を抽出
    description: >
      Extract prominent colors from current rendering canvas. Click on the color to apply it to AIRI. Try to extract multiple times, with the model in different poses, if the colors are not desirable.
    button-extract:
      title: 抽出
  animation:
    title: アニメーション
    focus:
      title: Enable mouse tracking
      description: Look at the cursor while it is moving. Idle eye movement resumes after the cursor stops.
      offset: Eye offset(%)
    force-idle-eye-animation:
      title: Idle eye movement
      description: Randomly look around when there is no active cursor focus.
    blink-enable:
      title: Enable blink
      description: Let the model blink.
    auto-blink:
      title: Auto
      description: Use default blinking animation of the model
    force-auto-blink:
      title: Force
      description: Force blinking animation with external timer
    blink-mode:
      title: Blink mode
      description: Choose the model built-in blink or AIRI's forced blink timer.
    idle-motion:
      title: Idle animation
      no-motion: No animation available
      placeholder: Select animation
      disable-motion: Disabled
      disable-motion-description: Disable idle animation
  parameters:
    title: Model Parameters
    render-scale:
      title: レンダリングスケール
    fps:
      title: FPS
      description: Limit rendering frame rate
      options:
        unlimited: '∞'
    shadow: Drop shadow
    reset-parameters: デフォルトのパラメータにリセット
  clear-model-cache: Clear model cache
  expressions:
    title: Expressions
    override-toggle: Expression system
    sdk-preset-preserved-notice: >
      SDK expression manager and eye blink are preserved when disabled.
    no-expression: No expressions available for this model.
    llm-integration-wip: LLM tool integration is not yet wired up.
    save-default: Save expression defaults
    reset: Reset all expressions
    expose-to-llm-toggle: Expose to LLM
    expose-to-llm-options:
      none: 無し
      all: すべて
      custom: Custom
microphone: マイク
models: モデル
pages:
  account:
    title: アカウント
    description: プロフィールを表示し、アカウントを管理します
    notLoggedIn: アカウントにログインして、全機能をご利用ください
    login: サインイン
    logout: サインアウト
    fluxBalance: Flux 残高
    viewFluxDetails: 詳細を見る
    signedInAs: サインイン済み
    profile:
      tab: Profile
      title: Profile
      description: Manage your public display name.
      name:
        label: Display name
        placeholder: How others see you
      avatar:
        gravatarNotice: Avatar from Gravatar.
        gravatarLink: Manage on gravatar.com
      action:
        save: Save changes
      message:
        saved: Profile updated.
      error:
        fallback: 変更を保存できませんでした
    connections:
      tab: 接続済みアカウント
      title: 接続済みアカウント
      description: Sign in to AIRI through these providers. Unlink to revoke access, then link again to switch to a different account.
      status:
        linked: リンク済
        notLinked: Not linked
        linkedSince: Linked on {date}
      action:
        link: Link
        unlink: リンク解除
      message:
        loading: 接続されたアカウントを読み込んでいます...
        unlinked: '{provider} は切断されました。'
        linked: '{provider} が接続されました。'
        linkStarted: Redirecting to {provider}…
      error:
        listFailed: Could not load connected accounts.
        unlinkFailed: Could not unlink this account.
        linkFailed: Could not start the link flow.
        accountAlreadyLinkedToDifferentUser: この OAuth アカウントは別の AIRI アカウントにすでに連携されています。別のプロバイダーアカウントを選ぶか、先に別の AIRI アカウントから連携を解除してください。
        oauthCallbackFailed: この OAuth アカウントを連携できませんでした。もう一度試すか、別のプロバイダーアカウントを選んでください。
        lastAccount: "これはあなたの唯一のサインイン方法です。\nリンクを解除する前にパスワードを設定してください。"
    security:
      tab: セキュリティ
      title: セキュリティ
      description: Change your password. Your other devices will be signed out.
      setDescription: You signed in via a social provider, so there is no current password yet. We'll email a secure link to set one.
      currentPassword:
        label: 現在のパスワード
        placeholder: 現在のパスワードを入力してください
      newPassword:
        label: 新しいパスワード
        placeholder: 8文字以上で設定してください
      confirmPassword:
        label: 新しいパスワードを確認
        placeholder: 新しいパスワードをもう一度入力してください
      action:
        changePassword: パスワードを変更
        sendSetLink: Email me a link to set my password
      message:
        changed: Password changed. Other sessions have been signed out.
        setLinkSent: Check {email} for the link to set your password.
      error:
        fallback: We could not change your password.
        setLinkFailed: We could not send the password setup link.
        passwordMismatch: New password and confirmation do not match.
        passwordSameAsCurrent: New password must differ from the current one.
    danger:
      tab: Danger Zone
      title: Danger Zone
      description: Irreversible account actions live here.
      deleteAccount:
        title: Delete account
        description: Permanently delete your account and personal data.
        action: Delete account
        modal:
          title: Delete account?
          warning: This cannot be undone. Active subscription will be canceled, Flux balance cleared.
          confirmEmail:
            label: Type your email to confirm
            placeholder: ''
            mismatch: Email does not match.
          confirm: Send confirmation email
          cancel: Cancel
        message:
          emailSent: Check {email} for the deletion link.
        error:
          fallback: Could not start deletion. Try again later.
  card:
    activate: 有効化
    active: 有効
    active_badge: 現在有効
    activation_notice: '{name} に切り替えました。現在の会話ではこのキャラクターが使用されます。'
    cancel: 操作の取消
    save: 変更を保存
    save_and_activate: 保存して有効化
    card_not_found: カードが見つかりません
    character: キャラクター
    close: 閉じる
    chat:
      provider: チャット / プロバイダー
    consciousness:
      model: 意識 / モデル
    vision:
      provider: ビジョン / プロバイダー
      model: ビジョン / モデル
    created_by: 作成者
    creator_notes: 作成者のメモ
    delete: 削除
    delete_card: カードを削除
    delete_confirmation: このカードを削除してもよろしいですか？
    description: AIRIキャラクターカードプリセットを使用する
    description_label: 説明
    drop_here: アップロードするにはここにドラッグ
    create_card: 新しいカードを作成
    edit_card: カードを編集
    creation:
      identity: 識別子
      name: 名前
      nickname: ニックネーム
      description: 説明
      behavior: 振る舞い
      greetings: 挨拶 (1行に1つ)
      settings: 設定
      version: バージョン
      create: 作成
      defaults:
        name: 名前
        personality: あなたはあらゆることに好奇心旺盛な普通の人間です。
        scenario: あなたは最近目覚め、前世のすべてを忘れてしまいました。
        systemprompt: 受け取ったメッセージに、本物の人間のように答えてください。
        posthistoryinstructions: 人間の真似をすることを忘れないでください。
      modules_info: >-
        このキャラクターカード用のモジュールを設定してください。設定されていない場合は、デフォルトのモジュール設定が使用されます。
      use_default: デフォルトを使用
      use_default_not_configured: デフォルトを使用 (未設定)
      fields_info:
        subtitle: >-
          ここに作成するキャラクターの詳細、履歴とコンテキスト、 およびあなたにどう返答してほしいか記述できます。
        name: このキャラクターの正式名称です。
        nickname: 優先的に使用されるニックネームも設定できます。
        description: このキャラクターの説明です。
        notes: 個人的なメモを追加したい場合はここに。
        personality: >-
          ここにキャラクターの性格を記述してください。 恥ずかしがり屋？好奇心旺盛？他には？
        scenario: 周囲の状況はどうなっていますか？現在の状況は？
        greetings_field: 挨拶
        greetings: キャラクターはどのように「こんにちは」と言うべきですか？
        systemprompt: AI LLMに対して、質問された際にどのように回答すべきかをここで説明してください。
        posthistoryinstructions: メッセージ履歴の後にAI LLMに読んでほしい内容をここに配置してください。
        version: >-
          カードのバージョン。以前のカードから変更を加える場合は、これを増やす必要があります。
        consciousness_model: このキャラクターの意識モデル(AIモデル)を選択してください。
        speech_model: このキャラクターの音声合成モデルと音声を選択してください。
      errors:
        name: 名前は有効であるか、空でない必要があります。
        version: 'エラー: 無効なバージョン番号です！'
        description: 'エラー: このカードの説明を入力してください。'
        personality: 'エラー: このキャラクターには性格が必要です。'
        scenario: 'エラー: シナリオは必須です。'
        systemprompt: 'エラー: システムプロンプトを入力してください。'
        posthistoryinstructions: 'エラー: 履歴の後のプロンプトは必須です。'
        invalid_artistry_json: 'Error: Artistry provider options contains invalid JSON.'
      none: None
    modules: モジュール
    name_asc: 名前(A-Z)
    name_desc: 名前(Z-A)
    no_cards: まだカードがありません。上のボタンをクリックしてアップロードしてください！
    no_results: 一致するカードが見つかりません
    personality: 性格
    posthistoryinstructions: 会話履歴の後の指示
    recent: 最近追加されたもの
    scenario: 背景
    search: カードを検索…
    sort_by: 並び替え
    body-model: 本体 / 表示モデル
    speech:
      provider: 音声/プロバイダー
      model: 発話/モデル
      voice: 発話/音声
    systemprompt: システムプロンプト
    title: AIRIカード
    try_different_search: 別の検索ワードを試してください
    export: Export
    exported: Card package exported
    export_failed: Failed to export card package
    imported: Card package imported
    import_missing_file: Card package is missing required files
    import_invalid_file: Card package file is invalid
    upload: アップロード
    upload_desc: Click or drag an AIRI card package to import
  memory:
    description: 記憶が保存され、整理される場所
    title: 記憶
  data:
    title: データ
    description: AIRIデータの保存、エクスポート、およびリセットの管理
    sections:
      chats:
        title: チャット セッション
        description: 保存されたチャットセッションをエクスポートまたはインポートします。
        export: チャットをエクスポート
        import: チャットをインポート
        delete: 全てのチャットセッションを削除
      models:
        title: モデル
        description: Remove imported Live2D, VRM, Spine, and MMD models.
        delete: すべてのモデルを削除
      modules:
        title: モジュール
        description: モジュールの設定と認証情報をリセットします。
        reset: モジュールの設定をリセット
      providers:
        title: プロバイダー
        description: すべてのプロバイダーの設定と資格情報をリセットします。
        reset: プロバイダーの設定をリセット
      danger:
        title: 危険区域
        description: この操作は元に戻せません。続行する前に必要なものをエクスポートしてください。
      all:
        title: すべてのデータを削除
        description: すべてのローカルの設定、プロバイダーの設定、モデルを消去します。
        delete: すべてのデータを削除
      desktop-folder:
        title: アプリデータフォルダを開く
        description: ファイルマネージャで AIRI のデータフォルダを開きます。
        open: フォルダを開く
      desktop:
        title: デスクトップの設定と状態をリセット
        description: AIRIデスクトップの設定と実行時の状態を消去します。
        center: Move desktop window to center
        reset: デスクトップのデータをリセット
    confirmations:
      tooltip: 本当によろしいですか？
      'yes': 'はい'
    status:
      exported: チャットセッションをエクスポートしました。
      imported: チャットセッションをインポートしました。
      import_error: チャットセッションのインポートに失敗しました。ファイルの形式を確認してください。
      chats_deleted: チャットセッションを削除しました。
      models_deleted: モデルを削除しました。
      modules_reset: モジュールの設定をリセットしました。
      providers_reset: プロバイダーの設定をリセットしました。
      all_deleted: すべてのローカルデータを削除しました。
      desktop_window_centered: Desktop window moved to screen center.
      desktop_reset: デスクトップのデータをリセットしました。
  models:
    description: Live2D, VRM, Spine, MMD, etc.
    title: モデル
    sections:
      section:
        live2d:
          title: Live2D
          description: Live2Dモデルと設定を構成
        vrm:
          title: VRM
          description: 3D VRMモデルと設定を構成
        scene: シーン
  modules:
    beat_sync:
      description: オーディオソースのビートに合わせて雰囲気を出す
      title: ビート同期
      sections:
        audio_source:
          actions:
            start_screen_capture: 画面キャプチャを開始
            stop: 停止
          description: ビートを検出するオーディオソースを選択します。
          title: オーディオソース
        beat_visualizer:
          title: ビートビジュアライザー
        parameters:
          advanced_parameters: 高度なパラメータ
          description: ビート検出パラメーターを調整します。
          title: パラメーター
          parameters:
            adaptive_threshold:
              description: >-
                時間の経過に伴う信号の変動に基づいて補正閾値を適用するかどうか。
              label: 補正閾値
            buffer_duration:
              description: 内部分析バッファの期間。
              label: バッファ期間
            envelope_filter_frequency:
              description: >-
                エネルギー変化を平滑化するために適用されるエンベロープフィルターの周波数。
              label: エンベロープフィルター周波数
            highpass_filter_frequency:
              description: >-
                サブベースノイズのような低周波を低減するために適用される ハイパスフィルターの周波数。
              label: ハイパスフィルター周波数
            lowpass_filter_frequency:
              description: >-
                声のような高周波を低減するために適用されるローパスフィルターの周波数。
              label: ローパスフィルター周波数
            min_beat_interval:
              description: 最大BPM、または検出されるビート間の最小間隔。
              label: 最大BPM / 最小ビート間隔
            sensitivity:
              label: 感度
            spectral_flux:
              description: スペクトルフラックスに基づく開始検出を有効にするかどうか。
              label: スペクトルフラックス
            warmup:
              description: より高い精度のために、ビートを検出する前にウォームアップを行うべきかどうか。
              label: ウォームアップ
    artistry:
      title: Artistry
      description: Image generation, scene background and drawing.
      page:
        title: Artistry Provider Configuration
        description: Select the active backend provider for image generation. Characters can override this in their Card settings.
      providers:
        none:
          name: None
          description: Bypass and disable the image generation module globally.
        comfyui:
          name: ComfyUI (ローカル)
          description: Use a local ComfyUI instance via WSL for image generation.
        replicate:
          name: Replicate.ai (Cloud)
          description: Use cloud-based models via the Replicate API.
        nanobanana:
          name: Nano Banana (Preview)
          description: Use Google AI Studio for image preview and reactions.
      card:
        description: Configure how AIRI generates images and visual content.
        comfyui_empty: No ComfyUI workflows configured. Go to Settings → Providers → ComfyUI to upload a workflow template.
        exposed_fields: '{count} exposed fields'
        open_on_replicate: Open on Replicate
        instruction_sync:
          title: ComfyUI Instruction Sync
          description: A specialized prompt is ready for your {workflowName} workflow. Applying this will overwrite current widget instructions so the AI knows how to use this specific template.
          apply: Apply Recommended Prompt
          keep: Keep Existing
      provider: Artistry Provider
      spawn_mode:
        label: Manifestation Mode (Spawn Mode)
        description: Choose how images are delivered to the interface.
        options:
          bg: Background Environment
          inline: Inline Chat
          widget: Overlay Widget
          bg_widget: Dual (Background + Widget)
      autonomous:
        title: Cinematic Autonomy (Autonomous Artist)
        description: When enabled, the "Producer" runs in parallel to the character to decide if a visual is needed. This prevents the character from forgetting to manifest scenes.
        threshold: Manifestation Threshold
        threshold_description: Use {min} for aggressive scene creation or {max} to require stronger evidence before generating.
        threshold_min: Always Generate (0%)
        threshold_max: Strict (100%)
      model:
        label: Artistry Model (Optional Override)
        description: Model identifier if needed by provider
      prompt-prefix:
        label: Artistry Prompt Default Prefix
        description: Pre-pended to every prompt sent to the image generator.
      options:
        label: Artistry Provider Options (JSON)
      widget-instructions:
        label: Widget System Prompt
        description: Custom instructions for the AI on how to use the generation capabilities.
    categories:
      essential: 必須
      messaging: Messaging
      gaming: Gaming
      artistry: Artistry
    consciousness:
      description: 性格、希望するモデルなど。
      sections:
        section:
          provider-model-selection:
            collapse: 折りたたむ
            custom_model_placeholder: カスタムモデル名を入力…
            current_model_label: '現在のモデル：'
            description: 意識に適したLLMプロバイダーを選択
            error: モデルの読み込みエラー
            health_check_failed: ヘルスチェックに失敗しました
            no_providers_configured_title: プロバイダーが設定されていません
            no_providers_configured_description: LLMプロバイダーを設定するにはここをクリック
            expand: 展開
            loading: 利用可能なモデルを読み込み中…
            manual_model_name: モデル名
            manual_model_placeholder: このプロバイダーで使用するモデル名を入力
            no_models: 利用可能なモデルがありません
            no_models_description: このプロバイダーのモデルが見つかりませんでした
            no_search_results: 一致するモデルがありません
            no_search_results_description: ワード「{query}」に一致するモデルがありません。別の検索語を試してください。
            not_supported: モデルリストはサポートされていません
            not_supported_description: このプロバイダーはモデルリスト機能をサポートしていません
            search_placeholder: モデルを検索…
            search_results: 結果{total}個中{count}個のモデルが見つかりました
            show_less: 表示を減らす
            show_more: もっと表示
            subtitle: プロバイダーからデフォルトモデルを選択してください
            title: モデル
      title: 意識
    description: 思考、視覚、音声合成、ゲームなど。
    gaming-factorio:
      description: Factorioをプレイ！
      title: Factorio
      enable: Factorio連携を有効にする
      enable-description: AIRIがFactorioゲームと通信できるようにする
      server-address: サーバーアドレス
      server-address-description: FactorioサーバーのIPアドレスまたはホスト名
      server-address-placeholder: サーバーアドレスを入力 (例： localhostまたは192.168.1.100)
      server-port: サーバーポート
      server-port-description: Factorioサーバーのポート番号 (デフォルト 34197)
      username: ユーザー名
      username-description: Factorioサーバーでのユーザー名
      username-placeholder: Factorioユーザー名を入力
      configured: Factorioは適切に設定されています！
    gaming-minecraft:
      description: Minecraftをプレイ！
      title: Minecraft
      enable: Minecraft連携を有効にする
      enable-description: >-
        ステージチャットにMinecraftの自己知識を含め、パッシブな実行時可視性を有効に維持する。
      configured: Minecraftは適切に設定されています！
      read-only:
        title: 読み取り専用シェル
        description: >-
          ステージは現在、Minecraftをパッシブなシェルとして公開しています。実行状態やトラフィックはここで確認できますが、サービスの構成設定については、引き続きMinecraftのサービスファイル側で管理されます。
      setup:
        title: セットアップ
        description: >-
          ボットのセットアップ手順については、以下のファイルで確認できます
      runtime:
        title: 観察されたランタイム
        connection: 接続
        latest-context: 最新のボットのコンテキスト
        waiting: ボット発信の新規コンテキストプッシュを待機しています。
        unknown: 不明
      debug:
        title: Minecraft のトラフィック
        empty: Minecraftのトラフィックはまだ観測されていません。
        source: 'ソース: {source}'
      status:
        service-online: サービスはオンラインです
        service-offline: サービスはオフラインです
        no-runtime-context: ボットのコンテキストがまだありません
        last-context-seconds: '最後のボットコンテキスト: {seconds}秒前'
        last-context-stale: '最後のボットコンテキスト: 期限切れ'
    hearing:
      description: 音声認識の動作を設定する
      title: 聴覚
      sections:
        section:
          provider-selection:
            description: 適切な音声認識プロバイダーを選択
          confidence-threshold:
            title: 信頼度の閾値
            description: >-
              信頼度の低い音声認識結果を除外することで、Whisperの幻覚現象を抑制します。0に近い値ほど厳格なフィルタリングとなり、左端までドラッグすると機能が無効になります。この機能はWhisper APIをサポートするプロバイダー（例：OpenAI、Groq）でのみ有効です。
            disabled: 無効
            verbose-json-note: >-
              注意：プロバイダーが verbose_json レスポンスをサポートしていない場合、この設定は無効になります。
            verbose-json-unsupported: >-
              プロバイダーから verbose_json セグメントが返されませんでした。信頼度フィルタリングは最後の文字起こしに影響を及ぼしませんでした。
    memory-long-term:
      description: 長期記憶固有の設定と管理
      title: 長期記憶
    memory-short-term:
      description: 短期記憶固有の設定と管理
      title: 短期記憶
    messaging-discord:
      description: Discordでのチャットとボイスチャット
      title: Discord
      enable: Discord連携を有効にする
      enable-description: AIRIがDiscordを介して対話できるようにする
      token: ボットトークン
      token-description: あなたのDiscordボットトークン
      token-placeholder: Discordボットトークンを入力
      configured: Discordは適切に設定されています！
    speech:
      description: 音声合成
      sections:
        section:
          playground:
            buttons:
              stop:
                label: 停止
            select-voice:
              loading: モデルを読み込み中…
              required: 音声を選択してください
          voice-pack:
            description: Select a curated voice for the active character
            empty: No Voice Packs available
            error: Error loading Voice Packs
            loading: Loading Voice Packs...
            title: Voice Pack
          provider-voice-selection:
            custom_model_placeholder: カスタムモデル名を入力…
            custom_voice_placeholder: カスタム音声IDを入力…
            description: 適切な音声プロバイダーを選択
            no_models: 利用可能なモデルがありません
            no_models_description: このプロバイダーのモデルが見つかりませんでした
            no_voices: 利用可能な音声がありません
            no_voices_description: このプロバイダーの音声が見つかりませんでした
            no_voices_hint: 下にカスタム音声名を入力できます。
            pause: 一時停止
            play_sample: サンプルを再生
            search_models_placeholder: モデルを検索…
            search_models_results: 結果{total}個中{count}個のモデルが見つかりました
            search_voices_placeholder: 音声を検索…
            search_voices_results: 結果{total}個中{count}個の音声が見つかりました
            unsupported_voice_warning_title: サポートされている音声がありません
            unsupported_voice_warning_content: >-
              別のモデルまたはプロバイダーを試してください。このモデルのすべての音声をできるだけ早くサポートできるように取り組んでいます。 緊急に必要な場合は、GitHubの https://github.com/moeru-ai/airi/issues でお知らせください。
            show_less: 表示を減らす
            show_more: もっと表示
            title: プロバイダー
          voice-settings:
            input-ssml:
              placeholder: SSMLテキストを入力…
            use-ssml:
              description: 平文の代わりに生のSSMLを入力できるようにする
              label: カスタムSSMLを使用する
      title: 音声
    title: モジュール
    vision:
      description: 視覚
      title: 視覚
    x:
      description: X / Twitterの閲覧と使用
      title: X / Twitter
      enable: X / Twitter連携を有効にする
      enable-description: AIRIがX / Twitterと対話できるようにする
      api-key: APIキー
      api-key-description: あなたのX / Twitter APIキー
      api-key-placeholder: あなたのX / Twitter APIキーを入力
      api-secret: APIシークレット
      api-secret-description: あなたのX / Twitter APIシークレット
      api-secret-placeholder: あなたのX / Twitter APIシークレットを入力
      access-token: アクセストークン
      access-token-description: あなたのX / Twitterアクセストークン
      access-token-placeholder: あなたのX / Twitterアクセストークンを入力
      access-token-secret: アクセストークンシークレット
      access-token-secret-description: あなたのX / Twitterアクセストークンシークレット
      access-token-secret-placeholder: あなたのX / Twitterアクセストークンシークレットを入力
      configured: X / Twitterは適切に設定されています！
    web-search:
      title: Web Search
      description: Let AIRI search the web for current information
      enable: Enable Web Search
      enable-description: Allow AIRI to search the web during chat
      api-key: Tavily API Key
      api-key-description: Web search is powered by Tavily. Get a free API key at tavily.com.
      api-key-placeholder: Enter your Tavily API key
      configured: Web search is ready to use!
    mcp-server:
      title: MCPサーバー
      description: Configure MCP servers and bring their tools into AIRI.
      config-path: Config file
      runtime-title: ランタイムの状態
      empty: No MCP servers yet — click "Add server" below to create one, or paste a config via "Edit JSON".
      error-title: Oops
      success-title: Done!
      existing:
        title: Configured
        description: Servers recorded in mcp.json. Click any row to expand and edit it.
        empty: Nothing here yet. Add one below!
      add:
        title: New
        description: "Fill in a new server, then click \"Save and restart\" — it'll move into \"Configured\" above."
        pending-badge: Unsaved
      status:
        unknown: not loaded
      actions:
        open-config: Reveal in file manager
        apply-and-restart: 変更を保存して再起動
        restart: MCP を再起動
        add-server: サーバーを追加
        add-env: Add var
        remove: Remove
        test: Test
        edit-json: Edit JSON
        close-json: Close
        format-json: Format
        reset-draft: Reset
        apply-json: Apply
        cancel: Cancel
        expand: Expand
        collapse: Collapse
      fields:
        identifier:
          label: Identifier
          description: Unique name; becomes the key in mcp.json.
          placeholder: e.g. filesystem
        command:
          label: Command
          description: Executable spawned over stdio.
          placeholder: e.g. npx
        args:
          label: Arguments
          description: One per line, in order.
          placeholder: "-y\nsome-package-name\n/tmp"
        cwd:
          label: Working directory
          description: Optional directory used as the process working directory.
          placeholder: e.g. /Users/you/project
        env:
          label: Environment
          description: Vars passed to the child process.
          key-placeholder: KEY
          value-placeholder: value
        enabled:
          label: Enabled
      json:
        title: Edit mcp.json
        description: 'Edit the raw JSON directly. Click "Apply" to load it into the form, then "Save and restart" to write it to disk.'
        placeholder: Paste mcp.json here…
      test:
        title: Test connection
        description: We'll spawn the server briefly to check the command works and see what tools it exposes.
        pick-server-label: Server
        no-servers: Nothing to test yet
        no-server-selected: Pick a server first.
        server-disabled: '"{name}" is disabled — enable it on the card first.'
        disabled-suffix: disabled
        untitled: untitled
        running: Testing…
        success: Connected! Found {count} tools in {ms}ms.
        failure: Connection failed after {ms}ms
      errors:
        empty-identifier: Server # {index} is missing an identifier.
        duplicate-identifier: Identifier "{name}" is used more than once — names need to be unique.
        empty-command: '"{name}" is missing a command.'
        invalid-shape: That doesn't look like a valid mcp.json — the root needs an "mcpServers" field.
      messages:
        opened: Opened {path} in your file manager
        json-applied: JSON applied to the form. Click "Save and restart" to persist it to disk.
        restarted: All restarted! {started} started, {failed} failed, {skipped} skipped.
  flux:
    title: Flux
    buy: チャージ
    currency: Currency
    description: 現在のFlux
    packagesError: パッケージの読み込みに失敗しました。後でもう一度お試しください。
    checkout:
      success: 支払いが完了しました！Fluxの残高が補充されました。
      canceled: 支払いはキャンセルされました。
      error: 何か問題が発生しました。後でもう一度お試しください。
    audit:
      title: 取引履歴
      time: 時間
      type: 種類
      detail: 詳細
      amount: 数量
      typeAddition: 補充
      typeConsumption: 利用状況
      typeInitial: 初期付与
      typePromo: Promo Grant
      loading: 履歴を読み込み中…
      empty: 取引記録はまだありません。
      loadMore: さらに読み込む
      delayHint: 使用記録は最大1分まで遅延する可能性があります
      ttsRequests: requests
    packages:
      title: Fluxパッケージ
      buy: チャージ
      description: 選択可能なFluxパッケージ。
  providers:
    catalog:
      edit:
        config-id-not-found: プロバイダ設定が見つかりません。
        definition-id-not-found: プロバイダーの定義が見つかりません。
        actions:
          more-options: その他のオプション
          delete: 削除
        validation:
          failed:
            title: プロバイダ設定を確認してください。認証に失敗しました。
            description: >-
              続行する場合は、現在の設定を保存することができます。
            action: このまま保存
        config:
          common:
            fields:
              field:
                api-key:
                  label: APIキー
                  description: このプロバイダへのリクエストを承認するために使用されるAPIキー
                  placeholder: sk-…
                base-url:
                  label: ベースURL
                  description: >-
                    リモートサービスへの接続に使用されるベースURL。多くの場合、http://localhost:11434/v1 または https://example.com/v1 のようになります。
                  placeholder: ベースURL…
                headers:
                  label: カスタムHTTPヘッダー
                  description: カスタムHTTPヘッダーを追加
                  key:
                    placeholder: キー
                  value:
                    placeholder: 値
                thinking-mode:
                  label: 思考モード
                  description: >
                    Ollamaの思考動作を制御します。GPT-OSSでは低/中/高レベルのみをサポートします。
                  options:
                    auto: 自動（プロバイダのデフォルト）
                    disable: 無効
                    enable: 有効
                    low: 低
                    medium: 中
                    high: 高
        validators:
          actions:
            validate: 検証
          empty: 検証ステップは利用できません。
          openai-compatible:
            check-config:
              title: 構成
            check-connectivity:
              title: 接続性
            check-supports-model-listing:
              title: モデル一覧
            check-supports-chat-completion:
              title: チャット補完
          status:
            validating: 検証中…
            valid: 検証成功
            invalid: エラー
          title: チェック
        providers:
          provider:
            ollama:
              troubleshooting:
                validators:
                  openai-compatible-check-connectivity:
                    label: Ollamaに追加設定が必要です
                    content: >-
                      残念ながら、Ollamaの接続チェックが失敗したようです。Ollamaインスタンスの場合、正常に動作させるためには追加の設定が必要です。OllamaアプリケーションまたはOllama CLIサーバーを起動する際には、<code>OLLAMA_HOST</code>環境変数を明示的に設定する必要があります。詳細な手順については、<a href="https://airi.moeru.ai/docs/en/docs/manual/integrations/providers/chat/ollama">Ollama統合ガイド</a>をご参照ください。
    common:
      continueAnyway: 続行する
      goToModelSelection: モデルを選択 →
      fields:
        field:
          api-key:
            label: APIキーを入力
      section:
        advanced:
          fields:
            field:
              headers:
                description: カスタムHTTPヘッダーを追加
                key:
                  placeholder: キー
                label: HTTPヘッダー
                value:
                  placeholder: 値
          title: 詳細
        basic:
          description: 必須設定
          title: 基本
        voice:
          title: 音声設定
    labels:
      recommended: Recommended
    filters:
      pricing: Pricing
      deployment: Deployment
      all: All
      free: Free
      paid: Paid
      internal: Internal
      local: ローカル
      cloud: クラウド
    categories:
      chat:
        title: チャット
        description: Text generation model providers. e.g. OpenRouter, OpenAI, Ollama.
      vision:
        title: Vision
        description: Vision model providers for image understanding.
      speech:
        title: Speech
        description: Speech (text-to-speech) model providers. e.g. ElevenLabs, Azure Speech.
      transcription:
        title: Transcription
        description: >-
          Transcription (speech-to-text) model providers. e.g. Whisper.cpp, OpenAI, Azure Speech
      artistry:
        title: Artistry
        description: Image generation and design model providers. e.g. ComfyUI, Replicate.
        items:
          comfyui:
            description: Local image generation runner.
          replicate:
            description: Cloud-based model inference service.
          nanobanana:
            description: Google AI Studio Image Preview.
    helpinfo:
      title: ここを初めて利用しますか？
      description: >
        AIRIが正常に思考し動作するためには、少なくとも1つの{chat}プロバイダーの設定が必要です。 これはAIRIシステム内に存在するキャラクターの脳と考えることができます。
    explained:
      chat: テキスト生成モデルプロバイダー。例： OpenRouter, OpenAI, Ollama。
      Speech: 音声 (テキスト読み上げ) モデルプロバイダー。例： ElevenLabs, Azure Speech。
      Transcription: >-
        音声認識 (speech-to-text) モデルプロバイダー。例： Whisper.cpp, OpenAI, Azure Speech
    description: LLM、音声プロバイダーなど。
    provider:
      app-local-audio-transcription:
        title: アプリ (ローカル)
        description: https://github.com/moeru-ai/xsai-transformers
      app-local-audio-speech:
        title: アプリ (ローカル)
        description: https://github.com/moeru-ai/xsai-transformers
      browser-local-audio-transcription:
        title: ブラウザ (ローカル)
        description: https://github.com/moeru-ai/xsai-transformers
      browser-local-audio-speech:
        title: ブラウザ (ローカル)
        description: https://github.com/moeru-ai/xsai-transformers
      alibaba-cloud-model-studio:
        description: bailian.console.aliyun.com
        title: Alibaba Cloud Model Studio
      amazon-bedrock:
        title: Amazon Bedrock
        description: aws.amazon.com/bedrock
        config:
          api-key:
            label: Bedrock API Key
            description: Amazon Bedrock API key (generate in AWS Console → Bedrock → API Keys)
            placeholder: bedrock-...
          region:
            label: AWS Region
            description: AWS region where Bedrock is enabled (e.g. us-east-1, us-west-2)
      anthropic:
        description: anthropic.com
        title: Anthropic | Claude
        helpinfo:
          title: 始める前に
          description:
            part1: >-
              Anthropicは最近、OpenAI SDK互換のベータサポートを発表しましたが
            part2: (詳細はこちら)
            part3: 詳細な実装を見ると、
            part4: >-
              OpenAI SDKと一致しない制限があり、現在このプロバイダーをブラウザで使用することはできません。
            part5: >-
              このプロバイダーを使用する必要がある場合は、 Serverless Function で実行される専用のプロキシバックエンド、
            part6: またはCORS制限をバイパスするためのCORSバイパスサービスが必要です。
      cloudflare-workers-ai:
        description: cloudflare.com
        fields:
          field:
            account-id:
              description: CloudflareアカウントID
              label: アカウントID
              placeholder: あなたのCloudflareアカウントID
            api-key:
              placeholder: Cloudflare APIキーを入力
        title: Cloudflare Workers AI
      common:
        status:
          validating: 検証中
          valid: 設定は有効なようです。
        fields:
          field:
            pitch:
              description: 合成音声のピッチを調整 (例： よりシャープに、またはより粗く)
              label: ピッチ
            speed:
              description: 音声の速度を調整
              label: 速度
            volume:
              description: 音声の音量を調整
              label: 音量
      deepgram-tts:
        description: deepgram.com
        title: Deepgram
      speech-noop:
        title: 無し
        description: 音声出力がありません。
      comfyui:
        settings:
          title: ComfyUI (Local)
          heading: ComfyUI Native API
          description: Connect to your local ComfyUI and bring your own workflows.
          info:
            what_you_need:
              label: What You Need
              value: ComfyUI running locally or on your network.
            how_to_export:
              label: How To Export
              value: Enable Dev Mode → "Save (API Format)".
            scope_boundary:
              label: Scope Boundary
              value: Model downloads & node installs are your job.
          connection:
            title: Connection
            connected: 接続済み
            failed: 接続に失敗しました
            error_prefix: エラー
            test: Test
            testing: Testing...
            unknown_error: Unknown connection error
            unknown_gpu: Unknown GPU
            server_url:
              label: Server URL
              description: The address where ComfyUI is running
              placeholder: http://localhost:8188
          cors:
            title: CORS Block Detected
            description: ComfyUI blocks requests from other applications by default. To allow AIRI to connect, you must start ComfyUI with the `--enable-cors-header "*"` flag.
            command: python main.py --enable-cors-header "*"
          workflows:
            title: Workflow Templates
            upload: Upload Workflow
            cancel_upload: Cancel
            empty: No workflows uploaded yet. Click "Upload Workflow" to import a workflow_api.json from ComfyUI.
            exposed_parameters: Exposed Parameters
            summary: '{nodes} nodes · {fields} exposed fields'
            remove: Remove
            config_snippet: Artistry Config Snippet
            copy_json: Copy JSON
            paste_hint: Paste this into your AIRI Card artistry config to override these nodes.
          upload:
            prompt: Drop or select a workflow_api.json file
            invalid_json: 無効なJSON形式です
            workflow_name:
              label: Workflow Name
              description: Give this workflow a recognizable name
              placeholder: e.g. Anime Text2Img
            select_fields: 'Select fields to expose to the AI agent:'
            fields_exposed: '{count} field(s) exposed'
            save: Save Workflow
      replicate:
        settings:
          title: Replicate.ai
          heading: Replicate.ai Configuration
          description: Configure your cloud image generation settings.
          api_key:
            label: APIキー
            description: Your Replicate API token (starts with r8_)
            placeholder: r8_XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
          default_model:
            label: Default Model
            description: Fallback owner/model string to use if the character card doesn't specify one
            placeholder: black-forest-labs/flux-schnell
          aspect_ratio:
            label: Aspect Ratio
            description: Default image aspect ratio (e.g. 16:9, 1:1, 9:16)
            placeholder: '16:9'
          inference_steps:
            label: Inference Steps
            description: Number of steps for the diffusion process (lower is faster, higher is better quality)
      nanobanana:
        settings:
          title: Nano Banana
          heading: Nano Banana (Google AIスタジオ)
          description: Configure Google Gemini's native image generation capabilities.
          api_key:
            label: APIキー
            description: Your Google AI Studio API Key
            placeholder: AIpk...
          preferred_model:
            label: Preferred Model
            description: The specific Gemini image preview model to use
          default_resolution:
            label: Default Resolution
            description: The target resolution for generated images
          model_options:
            nano_banana_2: Nano Banana 2 (Gemini 3.1 Flash Image)
            nano_banana_pro: Nano Banana Pro (Gemini 3 Pro Image)
            nano_banana: Nano Banana (Gemini 2.5 Flash Image)
      deepseek:
        description: deepseek.com
        title: DeepSeek
      elevenlabs:
        description: elevenlabs.io
        fields:
          field:
            simularity-boost:
              description: 音声特性の近似度
              label: 類似度ブースト
            speaker-boost:
              description: 話者近似度を上げる
              label: 話者ブースト
            speed:
              description: 音声生成速度
              label: 速度
            stability:
              description: 音声の安定性とランダム性
              label: 安定性
            style:
              description: 音声スタイルの誇張
              label: スタイル
        playground:
          buttons:
            button:
              test-voice:
                generating: 生成中…
                label: 音声をテスト
          fields:
            field:
              input:
                placeholder: 音声をテストするテキストを入力…
              language:
                description: 音声言語を選択
                label: 言語
              voice:
                description: 希望する音声を選択
                label: 音声
          title: 音声合成実験場
          validation:
            error-missing-api-key: 音声をテストするにはAPIキーを入力してください。
        title: ElevenLabs
      kokoro-local:
        description: Kokoro-82Mを使用したローカルテキスト読み上げ機能です。
        fields:
          field:
            model:
              label: モデルの選択
              description: モデルが小さいほど読み込みは速くなりますが、品質が若干低下する可能性があります。
        models:
          fp32-webgpu:
            description: >-
              WebGPU を使用した単精度モデル - 対応デバイスでの使用を推奨します
          fp32:
            description: 単精度モデル
          fp16:
            description: 半精度
          q8:
            description: 8ビット量子化
          q4:
            description: 4ビット量子化
          q4f16:
            description: 4ビット量子化（FP16）
        playground:
          default-text: こんにちは！これは音声合成システム Kokoro のテストです。
          title: 音声合成実験場
        title: Kokoro TTS (ローカル)
      fireworks:
        description: fireworks.ai
        title: Fireworks.ai
      google-gemini-audio-speech:
        description: aistudio.google.com
        title: Google Gemini
      microsoft-speech:
        description: speech.microsoft.com
        fields:
          field:
            region:
              description: 音声サービスリージョン
              label: リージョン
        title: Microsoft / Azure Speech
      index-tts-vllm:
        description: https://index-tts.github.io/
        title: Bilibili/IndexTTS
        callout_indextts2_unavailable_title: 限定的なサポート
        callout_indextts2_unavailable: 現在、IndexTTS2のサポートはご利用いただけません。IndexTTSをご利用ください。
      azure-ai-foundry:
        description: Azure AI Foundry
        title: Azure AI Foundry
      minimax:
        description: minimaxi.com
        title: MiniMax
      minimax-global:
        description: minimax.io
        title: MiniMax Global
      minimax-speech:
        description: minimax.io
        title: MiniMax Speech
      mimo:
        description: api.xiaomimimo.com
        title: Xiaomi MiMo
      mistral:
        description: mistral.ai
        title: Mistral
      moonshot:
        description: moonshot.ai
        title: Moonshot AI
      modelscope:
        description: modelscope.cn
        title: ModelScope
      novita:
        description: novita.ai
        title: Novita
      ollama:
        description: ollama.ai
        title: Ollama
      openai:
        description: openai.com
        title: OpenAI
      azure-openai:
        description: Azure OpenAI API
        title: Azure OpenAI
      openai-compatible:
        description: OpenAI互換
        title: OpenAI互換
      nvidia:
        description: build.nvidia.com
        title: NVIDIA NIM
      n1n:
        description: n1n.ai - 高性能なAI APIプロバイダー。
        title: n1n
      openpaths:
        description: openpaths.io
        title: OpenPaths
      openrouter:
        description: openrouter.ai
        title: OpenRouter
      openrouter-audio-speech:
        description: openrouter.ai
        title: OpenRouter
      perplexity:
        description: perplexity.ai
        title: Perplexity
      player2:
        description: player2.game
        title: Player2
      together:
        description: together.ai
        title: Together.ai
      google-generative-ai:
        description: gemini.google.com
        title: Google Gemini
      groq:
        description: groq.com
        title: Groq
      featherless:
        description: featherless.ai
        title: Featherless AI
      lm-studio:
        description: lmstudio.ai
        title: LM Studio
      vllm:
        description: vllm.ai
        title: vLLM
      volcengine:
        description: volcengine.com
        fields:
          field:
            appId:
              description: コンソールで取得できるプロジェクトのApp ID
              label: App ID
        title: Volcano Engine
      volcengine-coding-plan:
        description: Volcengine Coding Plan
        title: Volcengine Coding Plan
      byteplus:
        description: byteplus.com
        title: BytePlus
      byteplus-coding-plan:
        description: BytePlus Coding Plan
        title: BytePlus Coding Plan
      xai:
        description: x.ai
        title: xAI
      zai:
        description: z.ai
        title: Z.ai
      302-ai:
        description: 302.AI
        title: 302.AI
      comet-api:
        description: CometAPI.com
        title: Comet API
      cerebras:
        description: cerebras.ai
        title: Cerebras
      aliyun-nls:
        description: Aliyun NLS
        title: Aliyun NLS
      browser-web-speech-api:
        description: ブラウザネイティブSTT (Chrome/Edge/Safariが必要)
        title: Web Speech API
      official:
        title: 公式プロバイダー
        description: AIRIが提供する公式AIプロバイダー。
        speech-title: 公式音声プロバイダー
        speech-description: AIRIが提供する公式テキスト読み上げプロバイダー。
        speech-streaming-title: Official Streaming Speech Provider
        speech-streaming-description: Official low-latency text-to-speech provider by AIRI (bidirectional WebSocket).
        transcription-title: 公式文字起こしプロバイダー
        transcription-description: AIRIが提供する公式の音声テキスト変換プロバイダー。
      transcriptions:
        playground:
          title: 文字起こし実験場
      aihubmix:
        title: AIHubMix
        description: https://aihubmix.com (10% off)
    title: プロバイダー
  connection:
    description: WebSocketサーバー接続の設定
    title: 接続
    websocket-url:
      description: 'WebSocket サーバーの完全なアドレス (例: ws://localhost:6121/ws)'
      label: WebSocket サーバーアドレス
      placeholder: ws://localhost:6121/ws
    server-hostname:
      label: Expose On Network
      description: >-
        Choose whether the AIRI gateway only listens on this device or can be reached from your local network.
      advanced-label: Bind Hostname
      advanced-description: >-
        Use a specific hostname or IP address when you need manual network binding.
      options:
        this-device: この端末
        all: All
        advanced: Advanced
    server-auth-token:
      label: 認証トークン
      description: >-
        Security token required by remote clients that connect to this gateway. When left empty, AIRI generates a new token automatically.
      placeholder: Auto-generate
    qr:
      title: Connect from Stage Pocket
      description: >-
        Scan this QR code from Stage Pocket to try all reachable local network addresses and save the first working one.
      refresh: Refresh
      image-alt: AIRI server channel connection QR code
      candidates: Candidate addresses
      token-hint: >-
        The QR code includes the auth token so Stage Pocket can authenticate after connecting. Do not share it publicly.
      errors:
        title: QR code unavailable
        unavailable: Failed to prepare the connection QR code.
    qr-scan:
      title: Quick Connect
      description: Scan the QR code from Tamagotchi to quick connect
      instructions: Point the camera at the AIRI connection QR code.
      action: Scan
      success:
        title: Connected address saved
        description: 'URL been used: {url}'
      errors:
        title: QR scan failed
        failed: Failed to scan or connect with the QR code.
  system:
    color-scheme:
      description: ステージの配色を変更します。
      title: 配色
    developer:
      description: 開発者向けオプション。
      title: 開発者
    general:
      description: ダークテーマ、言語など。
      title: 一般
    permissions:
      description: 現在の権限状態を確認します。
      title: 権限管理
    description: ステージをカスタマイズしよう！
    sections:
      section:
        custom-color:
          fields:
            field:
              primary-color:
                label: プライマリカラー
                rgb-on:
                  title: ダイナミックにやりたい！
          title: 配色
        developer:
          title: 開発者
          sections:
            section:
              performance-visualizer:
                title: パフォーマンスビジュアライザー
                description: FPS/ロングタスク/メモリーオーバーレイの切り替え
              markdown-stress:
                title: Markdown ストレス
                description: 大量のチャットデータを含むMarkdownの解析とレンダリング負荷のテスト
              use-magic-keys:
                title: マジックキー ツールを使用
                description: ショートカットをテスト
              audio-record:
                title: オーディオ録音
                description: オーディオ関連のロジックをテストする
              background-gradient-blending:
                title: 背景テーマカラーのブレンド
                description: テストブレンドとテーマの設定
              background-removal:
                title: 背景削除（WebGPUが必要）
                description: 背景削除ユーティリティ
              chat:
                title: チャット
                description: チャット
              gesture-circle:
                title: ジェスチャーサークル (デスクトップのみ)
                description: ジェスチャー認識をテスト
              image:
                title: 画像
                description: 画像
              polaroid:
                title: ポラロイド
                description: モデルを撮影するためのユーティリティ
              context-flow:
                description: >-
                  受信コンテキストの更新とチャットストリームの送信イベントを調査する
              websocket-inspector:
                title: WebSocketインスペクタ
                description: 生のWebSocketトラフィックを調査する
              vibrant:
                title: 色の抽出
                description: テスト色の抽出
              providers-transcription-realtime-aliyun-nls:
                title: Aliyun リアルタイム文字起こし
                description: >-
                  マイクの音声をAliyun NLSにストリーミングし、リアルタイムの文字起こしを確認する
              performance-playground:
                title: 機能実験場
                description: VRM表情 + TTSリップシンク プレイグラウンド
        theme-presets:
          presets:
            default:
              colors:
                color-1: AIRIグリーン
              description: AIRIによって用意された、デフォルトの緑がかったテーマカラー！
              title: デフォルトカラー
            morandi:
              colors:
                color-1: トープ
                color-2: ベージュ
                color-3: アッシュグレー
                color-4: ライトトープ
                color-5: アイボリー
                color-6: オリーブグレー
                color-7: サンド
                color-8: ウォームグレー
              description: ジョルジョ・モランディの絵画から着想を得た、柔らかく落ち着いたトーン
              title: モランディカラー
            monet:
              colors:
                color-1: スカイブルー
                color-2: ミスト
                color-3: サンド
                color-4: モスグリーン
                color-5: スイレン
                color-6: 小麦色
                color-7: スレートブルー
                color-8: セージ
              description: クロード・モネの作品から着想を得た、印象派のパレット
              title: モネカラー
            japanese:
              colors:
                color-1: 薄茶色
                color-2: 温かみのある灰茶色
                color-3: 暗い茶褐色
                color-4: コーヒー
                color-5: ブロンズ
                color-6: ゴールド
                color-7: マスタード
                color-8: 琥珀色
              description: 日本の伝統的な色調をもとにしたカラーパレット
              title: 日本の色
            nordic:
              colors:
                color-1: ノルディックブルー
                color-2: アイス
                color-3: フィヨルド
                color-4: スチール
                color-5: 氷河
                color-6: スレート
                color-7: 雲
                color-8: 石
              description: スカンジナビアのミニマリストな配色
              title: 北欧カラー
            chinese:
              colors:
                color-1: バラ色
                color-2: チャイニーズレッド
                color-3: スモーキーブラウン
                color-4: 竹緑色
                color-5: 濃紫
                color-6: 黄金色
                color-7: 群青
                color-8: 黄土色
              description: >-
                古代の染織品や陶磁器、絵画に由来する中国の伝統色
              title: 中国の伝統色
          title: 配色プリセット
    title: システム
  page:
    developers:
      open-devtools:
        title: 開発者ツールを開く
        button: 開く
  credits:
    buy: 購入
  scene:
    title: Scenes
    description: Customize the virtual environment for your characters.
    beta_label: Scenes System
    beta_description: Each character card specifies its own preferred background from this gallery. Setting it here will set it as the default for the currently active character.
    background_image:
      title: Active Character Background
      no_background: No background active for this character. Upload a square or landscape image for best results.
      upload: Upload to Gallery
      change: Change Background
      clear: Clear Default
    gallery:
      title: Scene Gallery
      empty: No images in gallery yet. Upload one above!
      set_as_global: Set as Character Default
      delete: Delete from Gallery
      global_badge: Character Default
      active_badge: Current Scene
      delete_confirm: Are you sure you want to delete this background?
    tip:
      label: Tip!
      description: Using a square image will leverage <b>cover</b> cropping in portrait mode, focusing on the center of the scene.
sections:
  section:
    general:
      title: 一般
theme:
  title: テーマ
  description: |
    AIRIの基本テーマをライトモードまたはダークモードに切り替えます。
title: 設定
voices: 音声
vrm:
  change-model:
    from-file: ファイルから読み込む
    from-file-select: 選択
    from-url: URL から読み込む
    from-url-confirm: 読み込み
    from-url-placeholder: VRMモデルのURLを入力
    title: モデルを変更
  title: VRM設定
  scale-and-position:
    model-info-title: モデルサイズ情報
    model-info-x: 幅 (X)
    model-info-y: 高さ (Y)
    model-info-z: 奥行き (Z)
    tips: |
      VRMモデルの初期位置を編集します。
      座標軸が視覚化されます。
    scale: スケール
    x: Xオフセット
    'y': Yオフセット
    z: Zオフセット
    fov: FOV (度)
    rotation-y: 回転 (Y軸)
    camera-distance: カメラ距離
    eye-tracking-mode:
      title: 視線
      options:
        option:
          camera: カメラ
          mouse: マウス
          disabled: 無効
  switch-to-vrm:
    title: Live2Dアバターに切り替えますか？
    change-to-vrm: Live2Dアバター設定に切り替えるにはここをクリック
  theme-color-from-model:
    button-extract:
      title: 抽出
  skybox:
    skybox-intensity: スカイボックスの強度
    skybox-specular-mix: 鏡面反射の混合
spine:
  title: Spine Settings
  scale-and-position:
    title: Scale And Position
    scale: Scale
    x: X
    'y': 'Y'
  theme-color-from-model:
    title: Extract colors from model
    button-extract:
      title: Extract
  animation:
    title: Animation
    idle-animation: Idle Animation
    mix-duration: Mix Duration (seconds)
    speed: Animation Speed
  appearance:
    title: 外観
  variant:
    title: Variant
    current-variant: Active Variant
  skin:
    title: Skin
    current-skin: Current Skin
  rendering:
    title: Rendering
    max-fps: Maximum FPS
    render-scale: Render Scale
  fps:
    options:
      unlimited: Unlimited
mmd:
  title: MMD Settings
  scale-and-position:
    title: Scale And Position
    scale: Scale
    x: X
    'y': 'Y'
    rotation: Rotation
  theme-color-from-model:
    title: Extract colors from model
    button-extract:
      title: Extract
  physics:
    title: Physics & Rig
    enabled: Enable physics (hair, skirt, accessories)
    ik: Enable IK (inverse kinematics)
    grant: Enable append-bone propagation
    gravity: Gravity strength
  gaze:
    title: Gaze
    tracking: Looking at
    options:
      cursor: Mouse
      camera: Camera
      none: Disabled
  animation:
    title: Animation
    idle-motion: Idle Motion
    import-motion: Import Motion (.vmd)
    play-once: Preview Animation
    remove: Remove motion
    description: >-
      Import VMD motion files, set one as the looping idle, or play any as a one-shot gesture. Map emotions to motions to play gestures alongside facial expressions.
  morphs:
    title: Morphs
    auto: (auto)
    revert: Revert to auto
    no-morphs: This model exposes no morphs.
    description: >-
      The renderer auto-detects standard Japanese morph names (あいうえお, まばたき). Override a slot here if your model uses non-standard names.
  materials:
    title: Materials
    no-materials: This model exposes no materials.
    description: >-
      Adjust the opacity of individual model parts (face, hair, clothing, accessories). Set a part to 0 to hide it.
tachie:
  title: Tachie Settings
  archive-description: Tachie models use .tachie.zip archives containing emotion-named images.
  scale-and-position:
    title: Scale And Position
    scale: Scale
    x: X
    'y': 'Y'
  theme-color-from-model:
    title: Extract colors from model
    button-extract:
      title: Extract
  rendering:
    title: Rendering
    render-scale: Render Scale
    shadow: Theme-colored drop shadow
websocket-secure-enabled:
  title: セキュア WebSocket (WSS) を有効にする
  description: >-
    開発モードでモバイル（pocket）のHTTPS接続を許可するために、WSS（WebSocket Secure）を有効にします。これにより自己署名証明書が自動的に生成されます。
wip:
  title: 開発中
  description: >-
    この機能は現在開発中で、まだ一般には公開されていません。今後のアップデートで利用可能になる予定ですので、しばらくお待ちください。
